import { defineStore } from 'pinia';
import { JoiningAuctionsRequestFilter, AuctionStatus } from '@/types/auction.type.ts';

export const useBetsFilterStore = defineStore('bets.filter', {
    state: (): JoiningAuctionsRequestFilter => ({
        brand_id: undefined,
        model_id: undefined,
        status: [AuctionStatus.InProgress],
        from_date: undefined,
        to_date: undefined,
        page: 1,
        sort: [{ start_date: 'desc' }],
    }),
});
